import { formatDate, formatDuration, formatTime, openUrl } from "../services";
import { Col, Icon, Row, TextLink } from "../lib";
import { Detail } from "./detail";
import { Tag } from "./tag";
import { useCallback } from "react";

type Props = {
  date: Date;
  duration: number;
  incall?: boolean;
  locationName: string;
  total: string;
  travelFee?: string;
  discounted?: boolean;
  placeId?: string | number;
  timeZone: string;
};

export function BookingDetails({
  date,
  duration,
  incall,
  locationName,
  total,
  travelFee,
  discounted,
  placeId,
  timeZone,
}: Props) {
  const openLocation = useCallback(() => {
    openUrl(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        locationName
      )}&query_place_id=${placeId}`
    );
  }, [locationName, placeId]);

  const bookingTime = `${formatDate(date, timeZone)} ${formatTime(date, timeZone)}`;

  const locationLink = (
    <Row.R>
      {incall && (
        <Col mr="2">
          <Tag label="incall" />
        </Col>
      )}
      <TextLink onPress={openLocation}>
        {locationName} <Icon name="open-in-new" small />
      </TextLink>
    </Row.R>
  );

  return (
    <Col>
      <Detail name="When" value={bookingTime} />
      <Detail name="Where" value={locationLink} />
      {!!travelFee && <Detail name="Travel fee" value={travelFee} />}
      <Detail name="How long" value={formatDuration(duration)} />
      <Detail name="Price" value={total} />
      {discounted && <Detail name="Premium price" value="Yes" />}
    </Col>
  );
}
